import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import { formatDate } from '../../../../../../domain/feature/hub/company/challenge/FormWrapper/behaviors/date'
import { IHubEventBasicFormState } from 'domain/feature/hub/company/events/FormWrapper/store/contracts'
import { IHubEventBasicFormFilesState } from 'domain/feature/hub/company/events/FormWrapper/file/store/contracts'
import { IEventForm } from 'domain/feature/hub/company/events/FormWrapper/constants'
import { eventForm } from '.'

enum Form {
  ConfigForm = 0,
  AddresForm = 1
}

enum Field {
  IsInPerson = 0,
  Name = 1,
  Description = 2,
  Website = 3,
  CoverImage = 4,
  HomePageSlider = 5,
  Archives = 6,
  StartDate = 7,
  EndDate = 8,
  StartTime = 9,
  EndTime = 10,
  IsPaid = 11,
  TicketDescription = 12,
  IsActive = 13
}

enum AddressField {
  Name = 0,
  AddressZipCode = 1,
  AddressLineOne = 2,
  AddressNumber = 3,
  AddressLineTwo = 4,
  AddressNeighborhood = 5,
  AddressCity = 6,
  AddressState = 7,
}

export const fillEvent = (values: IHubEventBasicFormState, files: IHubEventBasicFormFilesState): IEventForm[] => {
  const data = JSON.parse(JSON.stringify(eventForm))
  _.set(data, `[${Form.ConfigForm}].content[${Field.IsInPerson}].value`, _.get(values, 'isInPerson'))
  _.set(data, `[${Form.ConfigForm}].content[${Field.Name}].value`, _.get(values, 'name'))
  _.set(data, `[${Form.ConfigForm}].content[${Field.Description}].value`, _.get(values, 'description'))
  _.set(data, `[${Form.ConfigForm}].content[${Field.Website}].value`, _.get(values, 'website'))
  _.set(data, `[${Form.ConfigForm}].content[${Field.StartTime}].value`, _.get(values, 'startTime'))
  _.set(data, `[${Form.ConfigForm}].content[${Field.EndTime}].value`, _.get(values, 'endTime'))
  _.set(data, `[${Form.ConfigForm}].content[${Field.IsPaid}].value`, _.get(values, 'isPaid'))
  _.set(data, `[${Form.ConfigForm}].content[${Field.TicketDescription}].value`, _.get(values, 'ticketDescription'))
  _.set(data, `[${Form.ConfigForm}].content[${Field.IsActive}].value`, _.get(values, 'isActive'))

  _.set(
    data,
    `[${Form.ConfigForm}].content[${Field.StartDate}].value`,
    formatDate(_.get(values, 'startDate'))
  )
  _.set(
    data,
    `[${Form.ConfigForm}].content[${Field.EndDate}].value`,
    formatDate(_.get(values, 'endDate'))
  )

  readFiles(files, data, `[${Form.ConfigForm}].content[${Field.CoverImage}].archive`, 'coverImage')
  readFiles(files, data, `[${Form.ConfigForm}].content[${Field.HomePageSlider}].archive`, 'homePageSlider')
  _.set(data, `[${Form.ConfigForm}].content[${Field.Archives}].archives`, [])

  files.eventFiles.forEach((file, fileKey) => {
    readFiles(
      files,
      data,
      `[${Form.ConfigForm}].content[${Field.Archives}].archives[${fileKey}]`,
      `eventFiles[${fileKey}]`
    )
  })

  if (values.address.id != null && values.address.id !== '') {
    _.set(data, `[${Form.AddresForm}].content[0].content.id`, values.address.id)
  }
  _.set(data, `[${Form.AddresForm}].content[0].content.fields[${AddressField.Name}].value`, _.get(values, 'address.name'))
  _.set(data, `[${Form.AddresForm}].content[0].content.fields[${AddressField.AddressZipCode}].value`, _.get(values, 'address.addressZipCode'))
  _.set(data, `[${Form.AddresForm}].content[0].content.fields[${AddressField.AddressLineOne}].value`, _.get(values, 'address.addressLineOne'))
  _.set(data, `[${Form.AddresForm}].content[0].content.fields[${AddressField.AddressNumber}].value`, _.get(values, 'address.addressNumber'))
  _.set(data, `[${Form.AddresForm}].content[0].content.fields[${AddressField.AddressLineTwo}].value`, _.get(values, 'address.addressLineTwo'))
  _.set(data, `[${Form.AddresForm}].content[0].content.fields[${AddressField.AddressNeighborhood}].value`, _.get(values, 'address.addressNeighborhood'))
  _.set(data, `[${Form.AddresForm}].content[0].content.fields[${AddressField.AddressCity}].value`, _.get(values, 'address.addressCity'))
  _.set(data, `[${Form.AddresForm}].content[0].content.fields[${AddressField.AddressState}].value`, _.get(values, 'address.addressState'))

  return data
}

const readFiles = (
  formFilesState: IHubEventBasicFormFilesState,
  form: IEventForm[],
  path: string,
  type: string
): void => {
  const file = _.get(formFilesState, `${type}`)
  if (file === undefined) {
    _.set(form, `${path}`, {
      id: '',
      path: null,
      isDeleted: true,
      name: null,
      size: null,
      mimetype: null,
      extension: null,
      type: null,
      content: null,
      sourceFile: null
    })
    return
  }
  _.set(form, `${path}`, {
    id: _.get(formFilesState, `${type}.id`),
    path: _.get(formFilesState, `${type}.path`),
    isDeleted: false,
    name: _.get(formFilesState, `${type}.name`),
    size: _.get(formFilesState, `${type}.size`),
    mimetype: _.get(formFilesState, `${type}.mimetype`),
    extension: _.get(formFilesState, `${type}.extension`),
    type: _.get(formFilesState, `${type}.type`),
    content: _.get(formFilesState, `${type}.content`),
    sourceFile: _.get(formFilesState, `${type}.sourceFile`)
  })
}
